import { render, staticRenderFns } from "./Nearly30Questions.vue?vue&type=template&id=84ae6958&scoped=true"
import script from "./Nearly30Questions.vue?vue&type=script&lang=js"
export * from "./Nearly30Questions.vue?vue&type=script&lang=js"
import style0 from "./Nearly30Questions.vue?vue&type=style&index=0&id=84ae6958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ae6958",
  null
  
)

export default component.exports